import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=6229330a&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Icon.vue?vue&type=style&index=0&id=6229330a&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6229330a",
  null
  ,true
)

export default component.exports